

export const frontMatter = {
	sidebar_position: 80
};
export const contentTitle = 'Fill ratio';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-features-regions-of-interest-fill-ratio-md-849.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    annotation: "annotation",
    code: "code",
    em: "em",
    h1: "h1",
    header: "header",
    math: "math",
    mfrac: "mfrac",
    mi: "mi",
    mo: "mo",
    mrow: "mrow",
    p: "p",
    pre: "pre",
    semantics: "semantics",
    span: "span",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "fill-ratio",
        children: "Fill ratio"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Ratio of the actual filled space to the total available space."
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Roi.html#fillRatio",
        title: "github.io link",
        children: ["🔎 ROI options and parameters of ", _jsx(_components.code, {
          children: "fillRatio"
        }), " accessor"]
      })
    }), "\n", _jsx(_components.p, {
      children: "Fill ratio represents the ratio of how much of region's surface is filled with holes. Basically it helps understanding the actual ROI shape and how it is affected by holes in it. For example, if an object does not have holes or cavities in it the fill ratio will be equal to 1."
    }), "\n", _jsx(_components.p, {
      children: "The ratio is calculated in a simple manner:"
    }), "\n", _jsx(_components.span, {
      className: "katex-display",
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            display: "block",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "f"
                }), _jsx(_components.mi, {
                  children: "i"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "R"
                }), _jsx(_components.mi, {
                  children: "a"
                }), _jsx(_components.mi, {
                  children: "t"
                }), _jsx(_components.mi, {
                  children: "i"
                }), _jsx(_components.mi, {
                  children: "o"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mfrac, {
                  children: [_jsxs(_components.mrow, {
                    children: [_jsx(_components.mi, {
                      children: "S"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "a"
                    }), _jsx(_components.mi, {
                      children: "c"
                    }), _jsx(_components.mi, {
                      children: "e"
                    })]
                  }), _jsxs(_components.mrow, {
                    children: [_jsx(_components.mi, {
                      children: "S"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "a"
                    }), _jsx(_components.mi, {
                      children: "c"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mo, {
                      children: "+"
                    }), _jsx(_components.mi, {
                      children: "H"
                    }), _jsx(_components.mi, {
                      children: "o"
                    }), _jsx(_components.mi, {
                      children: "l"
                    }), _jsx(_components.mi, {
                      children: "e"
                    }), _jsx(_components.mi, {
                      children: "s"
                    }), _jsx(_components.mi, {
                      children: "I"
                    }), _jsx(_components.mi, {
                      children: "n"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "o"
                    }), _jsx(_components.mi, {
                      mathvariant: "normal",
                      children: "."
                    }), _jsx(_components.mi, {
                      children: "s"
                    }), _jsx(_components.mi, {
                      children: "u"
                    }), _jsx(_components.mi, {
                      children: "r"
                    }), _jsx(_components.mi, {
                      children: "f"
                    }), _jsx(_components.mi, {
                      children: "a"
                    }), _jsx(_components.mi, {
                      children: "c"
                    }), _jsx(_components.mi, {
                      children: "e"
                    })]
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "fill Ratio = \\frac{Surface}{Surface + HolesInfo.surface}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.8889em",
                verticalAlign: "-0.1944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.10764em"
              },
              children: "f"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "i"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.00773em"
              },
              children: "llR"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "a"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "t"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "i"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "o"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "2.2519em",
                verticalAlign: "-0.8804em"
              }
            }), _jsxs(_components.span, {
              className: "mord",
              children: [_jsx(_components.span, {
                className: "mopen nulldelimiter"
              }), _jsx(_components.span, {
                className: "mfrac",
                children: _jsxs(_components.span, {
                  className: "vlist-t vlist-t2",
                  children: [_jsxs(_components.span, {
                    className: "vlist-r",
                    children: [_jsxs(_components.span, {
                      className: "vlist",
                      style: {
                        height: "1.3714em"
                      },
                      children: [_jsxs(_components.span, {
                        style: {
                          top: "-2.314em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsxs(_components.span, {
                          className: "mord",
                          children: [_jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.05764em"
                            },
                            children: "S"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "r"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "a"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "ce"
                          }), _jsx(_components.span, {
                            className: "mspace",
                            style: {
                              marginRight: "0.2222em"
                            }
                          }), _jsx(_components.span, {
                            className: "mbin",
                            children: "+"
                          }), _jsx(_components.span, {
                            className: "mspace",
                            style: {
                              marginRight: "0.2222em"
                            }
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "Ho"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.01968em"
                            },
                            children: "l"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "es"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.07847em"
                            },
                            children: "I"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "n"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "o"
                          }), _jsx(_components.span, {
                            className: "mord",
                            children: "."
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "s"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "r"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "a"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "ce"
                          })]
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.23em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsx(_components.span, {
                          className: "frac-line",
                          style: {
                            borderBottomWidth: "0.04em"
                          }
                        })]
                      }), _jsxs(_components.span, {
                        style: {
                          top: "-3.677em"
                        },
                        children: [_jsx(_components.span, {
                          className: "pstrut",
                          style: {
                            height: "3em"
                          }
                        }), _jsxs(_components.span, {
                          className: "mord",
                          children: [_jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.05764em"
                            },
                            children: "S"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "u"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.02778em"
                            },
                            children: "r"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            style: {
                              marginRight: "0.10764em"
                            },
                            children: "f"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "a"
                          }), _jsx(_components.span, {
                            className: "mord mathnormal",
                            children: "ce"
                          })]
                        })]
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-s",
                      children: "​"
                    })]
                  }), _jsx(_components.span, {
                    className: "vlist-r",
                    children: _jsx(_components.span, {
                      className: "vlist",
                      style: {
                        height: "0.8804em"
                      },
                      children: _jsx(_components.span, {})
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose nulldelimiter"
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Where ", _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "H"
                }), _jsx(_components.mi, {
                  children: "o"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "s"
                }), _jsx(_components.mi, {
                  children: "I"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "f"
                }), _jsx(_components.mi, {
                  children: "o"
                }), _jsx(_components.mi, {
                  mathvariant: "normal",
                  children: "."
                }), _jsx(_components.mi, {
                  children: "s"
                }), _jsx(_components.mi, {
                  children: "u"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "f"
                }), _jsx(_components.mi, {
                  children: "a"
                }), _jsx(_components.mi, {
                  children: "c"
                }), _jsx(_components.mi, {
                  children: "e"
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "HolesInfo.surface"
              })]
            })
          })
        }), _jsx(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.8889em",
                verticalAlign: "-0.1944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "Ho"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "l"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "es"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.07847em"
              },
              children: "I"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.10764em"
              },
              children: "f"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "o"
            }), _jsx(_components.span, {
              className: "mord",
              children: "."
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "s"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "u"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "r"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.10764em"
              },
              children: "f"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "a"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "ce"
            })]
          })
        })]
      }), " is the surface property of the method that specifically calculates the information about ROI's holes."]
    }), "\n", _jsx(_components.p, {
      children: "In ImageJS fill ratio is a ROI class accessor that returns a ratio:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-ts",
        children: "const fillRatio = roi.fillRatio;\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

